export default __webpack_public_path__ + "58b3286838ee817d7981d71221226b14.otf";